export default {
  //* loadQuotes ---------------------------------------------------------------------------------------------------------------

  async loadQuotes({ rootGetters, commit }) {
    // load quotes from backend
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    const response = await fetch(base_address + "/getQuote/all", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      commit("setQuotes", resp_json);
      localStorage.setItem("quotes", JSON.stringify(resp_json));
    }
  },

  //* loadQuotesLazy ---------------------------------------------------------------------------------------------------------------

  async loadQuotesLazy({ rootGetters }, dati) {
    // load contacts from backend
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    const response = await fetch(base_address + "/getQuote/lazy", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      body: JSON.stringify(dati),
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      return resp_json;
    }
    return {};
  },

  //* patchQuote ---------------------------------------------------------------------------------------------------------------

  // update backend side
  async patchQuote({ rootGetters }, data_input) {
    // @payload needs the id of the quotes and all the attributes needed
    /*
			!ATTENTION:
			control the data being patched otherwise the patch oper. is not permitted
		*/
    // console.log({ ...data_input });
    var payload = { ...data_input };
    const idQuote = payload._id;
    // otherwise the patch is not permitted
    delete payload._id;
    delete payload.__v;
    delete payload.owner;
    delete payload.camping;
    delete payload.date_creation;
    // console.log(payload)
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"],
      data = JSON.stringify(payload);
    tok = "Bearer " + tok; // composition of the token
    var response = await fetch(base_address + "/editQuote/" + idQuote, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: data,
    });
    ret_val = await response.json(); // means ok, all right (http protocol)
    ret_val = { data: ret_val };
    if (response.ok) {
      ret_val["ok"] = true;
    } else {
      ret_val["ok"] = false;
    }
    return ret_val;
  },

  //* patchQuote ---------------------------------------------------------------------------------------------------------------

  // update backend side
  async patchQuoteNoDate({ rootGetters }, data_input) {
    // @payload needs the id of the quotes and all the attributes needed
    /*
			!ATTENTION:
			control the data being patched otherwise the patch oper. is not permitted
		*/
    // console.log({ ...data_input });
    var payload = { ...data_input };
    const idQuote = payload._id;
    // otherwise the patch is not permitted
    delete payload._id;
    delete payload.__v;
    delete payload.owner;
    delete payload.camping;
    delete payload.date_creation;
    // console.log(payload)
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"],
      data = JSON.stringify(payload);
    tok = "Bearer " + tok; // composition of the token
    var response = await fetch(base_address + "/editQuoteNoDate/" + idQuote, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: data,
    });
    ret_val = await response.json(); // means ok, all right (http protocol)
    ret_val = { data: ret_val };
    if (response.ok) {
      ret_val["ok"] = true;
    } else {
      ret_val["ok"] = false;
    }
    return ret_val;
  },

  //* addQuote ---------------------------------------------------------------------------------------------------------------

  async addQuote({ rootGetters }, payload) {
    // @payload needs the quotes infos needed
    /**
		 *! Payload form:
		 *
		 *
		 * {
		 * 	name: {
				type: String,
				required: true,
				trim: true,
			},
			date_creation:{
				type: Date,
				default: new Date()
			},
			status:{
				type: String,
				default: "Nuovo"
			},
			note:{
				type: Object,
				default: {}
			},
			payload:{ // used by preventivo generation, must be JSON string
				type: String,
				default: ""
			},
			contact: { // referred contact
				type: mongoose.Schema.Types.ObjectId,
				required: true,
				ref: "contacts",
			},
		 * }
		 */
    if (!payload.name || payload.name === "") {
      payload.name = "undefined";
    }
    if (payload.contact === "") {
      payload.contact = undefined;
    }
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    var response = await fetch(base_address + "/addQuote", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(payload),
    }).catch((e) => {
      console.log(e);
    });
    if (response.ok) {
      ret_val = 200; // means ok, all right (http protocol)
    }
    return ret_val;
  },

  //* addDraft ---------------------------------------------------------------------------------------------------------------

  async addDraft({ rootGetters }, payload) {
    // @payload needs the quotes infos needed
    /**
		 *! Payload form:
		 *
		 *
		 * {
		 * 	name: {
				type: String,
				required: true,
				trim: true,
			},
			date_creation:{
				type: Date,
				default: new Date()
			},
			status:{
				type: String,
				default: "Nuovo"
			},
			note:{
				type: Object,
				default: {}
			},
			payload:{ // used by preventivo generation, must be JSON string
				type: String,
				default: ""
			},
			contact: { // referred contact
				type: mongoose.Schema.Types.ObjectId,
				required: true,
				ref: "contacts",
			},
		 * }
		 */
    if (!payload.name || payload.name === "") {
      payload.name = "undefined";
    }
    if (payload.contact === "") {
      payload.contact = undefined;
    }
    var tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    var response = await fetch(base_address + "/addQuote", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(payload),
    }).catch((e) => {
      console.log(e);
    });
    const resp = await response.json();
    return resp;
  },

  //* addDraftCamp ---------------------------------------------------------------------------------------------------------------

  async addDraftCamp({ rootGetters }, payload) {
    var idCamp = payload[0];
    payload = payload[1];
    if (!payload.name || payload.name === "") {
      payload.name = "undefined";
    }
    if (payload.contact === "") {
      payload.contact = undefined;
    }
    var base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    var response = await fetch(base_address + "/addQuoteCamp", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify({ camp: idCamp, payload: payload }),
    }).catch((e) => {
      console.log(e);
    });
    const resp = await response.json();
    return resp;
  },

  //* deleteQuote ---------------------------------------------------------------------------------------------------------------

  async deleteQuote({ rootGetters }, id) {
    // @payload needs the quotes infos needed
    /*
			! ATTENTION:
			Not already implemented
		*/
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    await fetch(base_address + "/deleteQuote/" + id, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).then((response) => {
      if (response.ok) {
        ret_val = 200; // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },

  //* getListiniCV ---------------------------------------------------------------------------------------------------------------

  async getListiniCV({ rootGetters }, data) {
    // load quotes from backend
    var tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    var response = await fetch(base_address + "/getListini", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(data),
    }).catch((e) => console.log(e));
    response = await response.json();
    // console.log(response)
    return response;
  },

  //* ratePlan ---------------------------------------------------------------------------------------------------------------

  async ratePlan({ rootGetters }) {
    // load quotes from backend
    var tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    var response = await fetch(base_address + "/ratePlan", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    response = await response.json();
    // console.log(response)
    return response;
  },

  //* quoteQuery ---------------------------------------------------------------------------------------------------------------

  async quoteQuery({ rootGetters }, data) {
    // load quotes from backend
    var tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    var response = await fetch(base_address + "/quoteQuery", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(data),
    }).catch((e) => console.log(e));
    response = await response.json();
    return response;
  },

  //* getPreventivoNoAuth ---------------------------------------------------------------------------------------------------------------

  async getPreventivoNoAuth({ rootGetters }, params) {
    // load quotes from backend
    const idPrev = params.idPrev;
    const idCamp = params.idCamp;
    var tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    // possibile aggiungere anche il check sul cliente per essere più sicuri
    var response = await fetch(
      base_address + "/getQuoteNoAuth/" + idCamp + "/" + idPrev,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors", // no-cors, *cors, same-origin
      }
    ).catch((e) => console.log(e));
    response = await response.json();
    return response;
  },

  //* segnaVisualizzazione ---------------------------------------------------------------------------------------------------------------

  async segnaVisualizzazione({ rootGetters }, params) {
    // load quotes from backend
    const idPrev = params.idPrev;
    const idCamp = params.idCamp;
    var base_address = rootGetters["settings/getBaseAddress"];
    // possibile aggiungere anche il check sul cliente per essere più sicuri
    await fetch(base_address + "/visualizzato/" + idCamp + "/" + idPrev, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    return 200;
  },

  //* rinominaPreventivo ---------------------------------------------------------------------------------------------------------------

  async rinominaPreventivo({ rootGetters }, params) {
    // load quotes from backend
    const idPrev = params.idPrev;
    const idCamp = params.idCamp;
    const nome = params.nome;
    var base_address = rootGetters["settings/getBaseAddress"];
    // possibile aggiungere anche il check sul cliente per essere più sicuri
    await fetch(base_address + "/rinominaPreventivo/" + idCamp + "/" + idPrev, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify({ nome: nome }),
    }).catch((e) => console.log(e));
    return 200;
  },

  //* accettaPreventivo ---------------------------------------------------------------------------------------------------------------

  async accettaPreventivo({ rootGetters }, params) {
    // load quotes from backend
    const idPrev = params.idPrev;
    const idCamp = params.idCamp;
    const idx = params.idx;
    var base_address = rootGetters["settings/getBaseAddress"];
    // possibile aggiungere anche il check sul cliente per essere più sicuri
    var preventivoAccettato = await fetch(
      base_address + "/accettaPreventivo/" + idCamp + "/" + idPrev + "/" + idx,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
        },
        mode: "cors", // no-cors, *cors, same-origin
      }
    ).catch((e) => console.log(e));
    preventivoAccettato = await preventivoAccettato.json();
    return preventivoAccettato;
  },

  //* richiestaDisp ---------------------------------------------------------------------------------------------------------------

  async richiestaDisp({ rootGetters }, params) {
    // load quotes from backend
    const idPrev = params.idPrev;
    var tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    var response = await fetch(base_address + "/richiestaDisp/" + idPrev, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    response = await response.json();
    return response;
  },

  //* invioPrenotazione ---------------------------------------------------------------------------------------------------------------

  async invioPrenotazione({ rootGetters }, params) {
    // load quotes from backend
    const idPrev = params.idPrev;
    const risorse = params.risorse;
    var tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    var response = await fetch(
      base_address + "/inserisciPrenotazione/" + idPrev,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors", // no-cors, *cors, same-origin
        body: JSON.stringify({
          risorse: risorse,
        }),
      }
    ).catch((e) => console.log(e));
    // console.log(response)
    response = await response.json();
    // console.log(response)
    return response;
  },

  //* tipologieBOL ---------------------------------------------------------------------------------------------------------------

  async tipologieBOL({ rootGetters }, payload) {
    // load quotes from backend
    var tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    var response = await fetch(base_address + "/tipologieBOL", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(payload),
    }).catch((e) => console.log(e));
    response = await response.json();
    // console.log(response)
    return response;
  },

  //* getQuote ---------------------------------------------------------------------------------------------------------------

  async getQuote({ rootGetters }, id) {
    // load contacts from backend
    /*
        ! ATTENTION:
        commit to store not added !
      */
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    const response = await fetch(base_address + "/getQuote/" + id, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      return resp_json;
    }
    return {};
  },

  //* addAttempt ---------------------------------------------------------------------------------------------------------------

  async addAttempt({ rootGetters }, id) {
    // load contacts from backend
    /*
        ! ATTENTION:
        commit to store not added !
      */
    var tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    const response = await fetch(base_address + "/addAttempt/" + id, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    if (response.ok) {
      return 200;
    }
    return 400;
  },
};
